export default {"src":"/_next/static/media/gold.cbf37a4e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};